import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Keys} from '../../model/constants';
import * as Immutable from "immutable";

import {SelectionStates, SelectionModes, isSelectionVisible} from './editor/SelectionManager'
import {applyPropMutation, getPropMutationState} from '../../model/action-creators/mutation-actions'
import {appendEditableCell} from "./TableUtils";
import {compare} from "../../utils";
class AssLstTable extends React.Component {


    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.hasWorkSesion =  !props.currentWorkSession.isEmpty();
    }

    componentWillReceiveProps(nextProps) {
        this.hasWorkSesion = nextProps.currentWorkSession && !nextProps.currentWorkSession.isEmpty()

    }
    getHeaderColumns() {
        const colNames = ['Id', 'Name']
        .concat(this.props.groups.toSeq().valueSeq().map((v) => {return v.get('shortName')}).toArray());
        colNames.unshift("Active")
        if( this.hasWorkSesion) {
            colNames.unshift("W")
        }
        let i = 0;
        return colNames.map(c => <th key={i++}>{c}</th>)
    }

    getAssigneeColumns(assignee) {

        const mutation = this.props.mutations.getIn([Keys.MutationType.ASSIGNEE, assignee.get(Keys.ID) ], null);

        const computedGroups = mutation
            ?applyPropMutation(assignee, Keys.Assignee.GROUPS, mutation)
            :assignee.get(Keys.Assignee.GROUPS, Immutable.Set());

        const columnContent = [
            {
                className:'',
                value:assignee.get(Keys.ID)
            },
            {
                className:'',
                value:assignee.get(Keys.Assignee.FIRST_NAME) + " " + assignee.get(Keys.Assignee.LAST_NAME)
            },
        ]
        .concat(
            this.props.groups.map((group) => {
                return {
                    className: '',
                    value:computedGroups.contains(group.get(Keys.ID)) ? group.get('shortName') : ""
                }
            }).toArray()
        );
        columnContent.unshift(appendEditableCell('ass-lst__work-session-cell', assignee, mutation, Keys.Assignee.ACTIVE, 'A'));
        if( this.hasWorkSesion) {
            columnContent.unshift(appendEditableCell('ass-lst__work-session-cell', assignee, mutation, Keys.Assignee.IN_WORK_SESSION, 'W'));
        }

        let i = 0;
        return columnContent.map(c => <td className={c.className} key={i++}>{c.value}</td>)

    }
    getAssigneeRows() {
        const {state, recordOrder, selectedItems, lastItemClicked, mode} = this.props.selectionInfo;
        const selectionVisible = isSelectionVisible(state);
        const rows = this.props.assignees.valueSeq().sort((a, b) =>
            compare(a.get(Keys.Assignee.FIRST_NAME), b.get(Keys.Assignee.FIRST_NAME)).thenCompare()
                .thenCompare(a.get(Keys.Assignee.LAST_NAME), b.get(Keys.Assignee.LAST_NAME))
                .result()
        ).map(
            assignee => {
                recordOrder(assignee,  'assignee');
                let selected = selectedItems.contains(assignee);
                let lastSelected = (assignee === lastItemClicked); // NOTE: if we filter this item out, the range selection will start from the same item
                let classNames = ['ass-lst__row'];
                if( selected&&selectionVisible) {
                    classNames.push('ass-lst__row--selected');
                }
                if ( lastSelected&&mode!==SelectionModes.TOGGLE&&selectionVisible) {
                    classNames.push('ass-lst__row--last-clicked');
                }
                const columns = this.getAssigneeColumns(assignee);
                const id = assignee.get(Keys.ID);
                return (<tr
                    key={id}
                    data-assignee-id={id} // so that we can find our assignee in the click handler
                    className={classNames.join(" ")}
                    onClickCapture={this.handleClick}
                >{columns}</tr>)
            }
        );
        return rows;
    }
    handleClick(event) {
        const id = event.currentTarget.getAttribute('data-assignee-id');
        const assignee = this.props.assignees.get(id);
        if ( assignee) {
            this.props.selectionInfo.handleClick(assignee, 'assignee');
        } else {
            console.warn("handleClick: couldn't find assignee with id: "+id);
        }
    }

    render() {
        return (
            <div>

                <table height="500" className="ass-lst__table noselect">
                    <thead>
                    <tr>
                        {this.getHeaderColumns()}
                    </tr>
                    </thead>
                    <tbody>
                    { this.getAssigneeRows()}
                    </tbody>
                </table>
            </div>

        )
    }
}

AssLstTable.propTypes = {
    selectionInfo:React.PropTypes.object,
    assignees:ImmutablePropTypes.map.isRequired,
    groups:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
};


export default AssLstTable



// WEBPACK FOOTER //
// ./src/ui/components/AssLstTable.js